import * as React from "react";
import * as cls from "./FormActions.module.scss";
export { FormActions };
/**
 * Контейнер для кнопок формы.
 * @param {Object} props - Атрибуты элемента.
 * @param {JSX.Element} props.children - Содержимое.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * import {Form, FormActions} 
 *   from "../personal-studio-components/form/index.js";
 * <Form onSubmit={(event) => {event.preventDefault();}}>
 *   <FormActions>
 *     <Button type="primary" icon="sent">Отправить</Button>
 *   </FormActions>
 * </Form>
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function FormActions({ children }) {
  return <div className={cls.form_actions}>{children}</div>
}
